(() => {
  const initialize = () => {
    if (location.pathname.replace(/\/$/, '') !== '/apps/collective/retailer-referral') return;
    const frame = document.querySelector('.collective__activation-widget-frame');
    if (!frame || frame.closest('.cha-referral')) return;

    document.body.classList.add('cha-referral-page');
    frame.title = 'Chameleon Antenna retailer referral application';

    const surface = document.createElement('main');
    surface.className = 'cha-referral';
    surface.setAttribute('aria-labelledby', 'cha-referral-title');
    surface.innerHTML = `
      <section class="cha-referral__hero">
        <div class="cha-referral__shell">
          <p class="cha-referral__eyebrow">Authorized retail partnerships</p>
          <h1 id="cha-referral-title">Bring Chameleon Antenna systems to your customers</h1>
          <p>Tell us about your retail business, the operators you serve, and where you sell. Chameleon Antenna reviews each referral for brand fit, customer support capability, and a sustainable working relationship.</p>
          <div class="cha-referral__steps" aria-label="Retailer referral process">
            <article><span>01</span><strong>Introduce your business</strong><small>Share your company, market, storefront, and customer-support information.</small></article>
            <article><span>02</span><strong>Chameleon reviews the fit</strong><small>We evaluate the proposed relationship and may request additional commercial details.</small></article>
            <article><span>03</span><strong>Build the relationship</strong><small>Approved retailers receive the next steps through the official Chameleon channel.</small></article>
          </div>
        </div>
      </section>
      <section class="cha-referral__application" aria-labelledby="cha-referral-application-title">
        <div class="cha-referral__shell">
          <div class="cha-referral__application-head"><p class="cha-referral__eyebrow">Secure Shopify application</p><h2 id="cha-referral-application-title">Retailer referral application</h2><p>Complete the form below as accurately as possible. Submission does not guarantee approval, pricing, territory, inventory, or commercial terms.</p></div>
          <div class="cha-referral__frame-shell"></div>
        </div>
      </section>`;
    frame.parentNode.insertBefore(surface, frame);
    surface.querySelector('.cha-referral__frame-shell').appendChild(frame);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();
